import { useState } from "react";
import '../../styles/buttonyesno.css'

const ButtonYesNo = ({
  onClick,
  width,
  state,
  height,
  Yes="Yes",
  No="No",
  disabled = false
}) => {
  const [btn, setBtn] = useState(false);
  return (
    <div style={{width:width , height: height, minHeight: height}} className="btn-decision flex flex-row items-center">
      <button style={{width: (width/2)  , left: `${state ? '0px' : ((width / 2) ) + 'px'}`, zIndex: 10 }} type="button" className={`selected btn-yesno  btn-yes `} disabled={disabled}><span>{state ? Yes : No}</span></button>
      <button style={{width: (width/2)  , left: `${state ? ((width / 2)) + 'px' : '0px'}` }} type="button" onClick={onClick} className={`${!state && ''} btn-no  `} disabled={disabled}><span>{state ? No : Yes}</span></button>
    </div>
  )
}

export default ButtonYesNo;